import { Component, OnDestroy, OnInit } from '@angular/core';
import { OrganisationsAdminService } from '../services/organisations-admin.service';
import { Organisation } from '../models/organisation';
import { Subscription } from 'rxjs';
import { ErrorCheckService } from '../services/error-check.service';

@Component({
    selector: 'app-organisation-list-wrapper',
    templateUrl: './organisation-list-wrapper.component.html',
    styleUrls: ['./organisation-list-wrapper.component.sass'],
    standalone: false
})
export class OrganisationListWrapperComponent implements OnInit, OnDestroy {
  protected organisations: Organisation[] = [];
  protected loading: boolean = true;
  protected authError: boolean = false;

  searchTerm: string = '';

  private subscription = new Subscription ();

  constructor(private orgAdminService: OrganisationsAdminService,
              private errorCheckService: ErrorCheckService
  ) { }

  ngOnInit(): void {
    this.fetchOrganisations();
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onSearchTermProvided(searchTerm: string): void {
    this.searchTerm = searchTerm;
    this.fetchOrganisations();
  }

  private fetchOrganisations = () => {
    this.loading = true;
    this.subscription.unsubscribe();
    this.subscription = this.orgAdminService
      .getOrganisations(this.searchTerm)
      .subscribe(
        organisations => {
          this.organisations = organisations;
          this.loading = false;
        }, ({ networkError })  => {
          this.authError = this.errorCheckService.isErrorUnauthorised(networkError);
          this.loading = false;
        });
  }
}
